import UserAccessManagementPanel from '@frontend/components/user-access/UserAccessManagementPanel';
import type { User } from '@frontend/types';

export interface ProjectMembershipPanelProps {
  expanded: boolean;
  onToggle: () => void;
  user: User | null;
  ecosystemId: string;
  projectId: string;
  ecosystemLabel?: string;
}

export default function ProjectMembershipPanel({
  expanded,
  onToggle,
  user,
  ecosystemId,
  projectId,
  ecosystemLabel,
}: ProjectMembershipPanelProps) {
  return (
    <div className="ecosystem-card admin-widget-card">
      <button type="button" className="admin-widget-header" onClick={onToggle}>
        <div className="admin-widget-header-main">
          <h3 className="ecosystem-title">Project memberships</h3>
        </div>
        <span className="admin-widget-toggle">{expanded ? '▾' : '▸'}</span>
      </button>
      {expanded ? (
        <div className="admin-widget-body">
          {ecosystemId && projectId ? (
            <UserAccessManagementPanel
              user={user}
              ecosystemId={ecosystemId}
              ecosystemLabel={ecosystemLabel}
              focusProjectId={projectId}
              hideCreateUser
            />
          ) : (
            <p className="tree-dashboard-muted">Select a project above.</p>
          )}
        </div>
      ) : null}
    </div>
  );
}
